import React, { useState, useEffect } from 'react';
import AccountCircle from '@material-ui/icons/AccountCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { useHistory } from 'react-router-dom';
import {
  InputAdornment,
  Button,
  TextField,
  Card,
  makeStyles,
} from '@material-ui/core';
import firebase from '../firebase/firebaseConfig';

const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: '5%',
    padding: '10px',
  },
  form: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: '20px',
    '@media (max-width: 610px)': {
      flexDirection: 'column',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '75%',
    },
  },
  formTextField: {
    '@media (max-width: 610px)': {
      color: 'green',
      marginBottom: '20px',
    },
  },
  title: {
    textAlign: 'center',
  },
  button: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  error: {
    textAlign: 'center',
    fontStyle: 'italic',
    color: 'red',
  },
}));

const SignIn = ({ handleShowSignIn, lang }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.SESSION)
      .then(() => {
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.
        return firebase.auth().signInWithEmailAndPassword(email, password);
      })
      .catch((error) => {
        // Handle Errors here.
        // var errorCode = error.code;
        // var errorMessage = error.message;
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    //Sign In
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        //Admin
        if (user.email === 'admin@savannahlatindance.com') {
          history.push({ pathname: '/admin', state: { userUID: user.uid } });
          return;
        }
        history.push({ pathname: '/account', state: { userUID: user.uid } });
      })
      .catch((error) => {
        // var errorCode = error.code;
        // var errorMessage = error.message;

        setErrorMsg(error.message);
      });
  };
  return (
    <Card className={classes.card}>
      <h1 className={classes.title}>Please Sign In</h1>
      <form className={classes.form} onSubmit={handleSubmit} autoComplete='off'>
        <TextField
          className={classes.formTextField}
          required
          label={lang === 'en' ? 'Email' : 'Correo Electrónico'}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <AccountCircle />
              </InputAdornment>
            ),
          }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          className={classes.formTextField}
          required
          type='password'
          label={lang === 'en' ? 'Password' : 'Contraseña'}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <VpnKeyIcon />
              </InputAdornment>
            ),
          }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <Button type='submit' variant='contained' color='secondary'>
          {lang === 'en' ? 'Sign In' : 'Iniciar Sesión'}
        </Button>
      </form>
      <p className={classes.error}>{errorMsg}</p>
      <Button
        className={classes.button}
        color='secondary'
        onClick={handleShowSignIn}
      >
        {lang === 'en' ? 'Sign Up' : 'Registrarse'}
      </Button>
    </Card>
  );
};

export default SignIn;
